import React, { useCallback } from 'react'
import { observer } from 'mobx-react'

import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

import { formatDate, formatTimeOnly } from 'admin/utils/helper'
import { useStores } from 'admin/hooks'
import CustomDataGrid from 'admin/components/data-grid'

const columns = [
  {
    field: 'createdAt',
    headerName: 'Transaction Date',
    flex: 1,
    renderCell: (params) => (
      <Stack
        direction="row"
        gap={1}
      >
        <Typography variant="h5">{formatDate(params.row.createdAt)}</Typography>
        <Typography variant="h5">{formatTimeOnly(params.row.createdAt)}</Typography>
      </Stack>
    ),
  },
  {
    field: 'transactionType',
    headerName: 'Transaction Type',
    flex: 1,
    sortable: false,
    renderCell: (params) => params.row.transactionType,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
    sortable: false,
    renderCell: (params) => {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <Typography variant="h5">{params.row.referenceId}</Typography>
          <Typography variant="h5">{params.row.description}</Typography>
        </div>
      )
    },
  },
  {
    field: 'paymentMethodType',
    headerName: 'Method',
    flex: 1,
    sortable: false,
    renderCell: (params) => params.row.paymentMethodType,
  },
  {
    field: 'amount',
    headerName: 'Amount',
    flex: 1,
    renderCell: (params) => {
      const amount = Number(params.row.amount).toFixed(2)
      return <Typography variant="h5">{String(amount) ? `$${amount}` : '-'}</Typography>
    },
  },
]

const TransferRequestDataGrid = () => {
  const { infoSectionStore, transferRequestStore } = useStores()
  const sDate = transferRequestStore.startDate
  const eDate = transferRequestStore.endDate

  const handlePageChange = useCallback((params) => {
    transferRequestStore.updatePage(params)
  }, [])

  const handlePageSizeChange = useCallback((param) => {
    transferRequestStore.updateRowsPerPage(param)
  }, [])

  const handleRowClick = useCallback((rowData) => {
    infoSectionStore.select(rowData.row)
  }, [])

  const onSortModelChange = (param) => {
    if (param.length === 1) {
      transferRequestStore.updateQuery('sortBy', param[0].field, true)
      transferRequestStore.updateQuery('sortDirection', param[0].sort, true)
      return
    }
    transferRequestStore.resetQuery(sDate, eDate)
  }

  return (
    <CustomDataGrid
      rows={transferRequestStore.list}
      columns={columns}
      handleRowClick={handleRowClick}
      handlePageChange={handlePageChange}
      rowCount={transferRequestStore.total}
      pageSize={transferRequestStore.rowsPerPage}
      page={transferRequestStore.currentPage}
      handlePageSizeChange={handlePageSizeChange}
      loading={transferRequestStore.loading}
      onSortModelChange={onSortModelChange}
      rowHeight={100}
    />
  )
}

export default observer(TransferRequestDataGrid)
